// Self-contained avatar generation.
//
// Avatars are rendered as inline SVG data URIs so they never depend on an
// external service (the old https://avatar.iran.liara.run host was unreliable
// and left every avatar blank when it was unreachable).

const AVATAR_COLORS = [
  '#5B8DEF', '#6C5CE7', '#00B894', '#E17055', '#0984E3',
  '#E84393', '#F39C12', '#16A085', '#D63031', '#8E44AD',
  '#2D98DA', '#EB3B5A', '#20BF6B', '#FA8231', '#3867D6',
  '#A55EEA', '#26DE81', '#FD9644', '#4B7BEC', '#FC5C65',
];

/** Deterministic 32-bit hash of a string. */
export function hashString(value: string): number {
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = ((hash << 5) - hash) + value.charCodeAt(i);
    hash = hash & hash; // force 32-bit integer
  }
  return Math.abs(hash);
}

// A simple white "person" silhouette (FontAwesome user-solid glyph).
const PERSON_GLYPH =
  `M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 ` +
  `482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 ` +
  `368.2 304 269.7 304l-91.4 0z`;

/**
 * Build an inline SVG data-URI avatar: a plain person silhouette on a colour
 * that's deterministic from `seed`, so the same contact always looks the same.
 * `label` is accepted for API compatibility but not rendered.
 */
export function generateAvatar(seed: string, label?: string): string {
  const color = AVATAR_COLORS[hashString(seed) % AVATAR_COLORS.length];
  const svg =
    `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'>` +
      `<rect width='100' height='100' rx='50' fill='${color}'/>` +
      `<svg x='28' y='26' width='44' height='50' viewBox='0 0 448 512'>` +
        `<path fill='#ffffff' d='${PERSON_GLYPH}'/>` +
      `</svg>` +
    `</svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}

/** True if a cached avatar URL points at the retired external host. */
export function isLegacyAvatarUrl(url: string): boolean {
  return typeof url === 'string' && url.includes('avatar.iran.liara.run');
}
